import { render } from "./fundamental2.vue?vue&type=template&id=775afd9e&scoped=true"
import script from "./fundamental2.vue?vue&type=script&lang=js"
export * from "./fundamental2.vue?vue&type=script&lang=js"

import "./fundamental2.vue?vue&type=style&index=0&id=775afd9e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775afd9e"]])

export default __exports__